import { ActionTree } from 'vuex';

// Shared types
import { Company } from '@coldtec/cos-types';

// Store types
import { RootState, CompanyAction, CompanyMutation } from '@/store/store.types';

// Api
import Api from '@/api';

/**
 *  Holding the actions of the company.
 */
export const Actions: ActionTree<RootState, RootState> = {

    /**
     *  Used to fetch and store the details of the company
     *  for which the tool is currently used.
     */
    async [CompanyAction.FETCH_DETAILS]({ commit }): Promise<void> {

        const { data } = await Api.client.get<Company>('/companies/active');

        commit(CompanyMutation.DETAILS, data);

        return Promise.resolve();

    },

};
